<template>
  <tr>
    <td>{{ fullName }}</td>
    <td>{{ roles }}</td>
    <td>{{ user.position }}</td>
    <td>{{ user.phone }}</td>
    <td>{{ user.department }}</td>
    <td>
      <status-title :status="user.status" :type="'user'"></status-title>
    </td>
    <td>
      <BaseActionMenu v-if="isUserAdmin">
        <template #actions>
          <div
            class="action-menu-item"
            v-for="(value, key) in availableActions"
            :key="key"
            @click="itemClicked(key)"
          >
            {{ value }}
          </div>
        </template>
      </BaseActionMenu>
    </td>
  </tr>
</template>

<script>
import { fullName } from '@/mixins/full-name.js'
import { userRights } from '@/mixins/user-rights.js'
import { userStatus } from '@/main.config.js'
import { getRoleTitle } from '@/mixins/get-role-title.js'
import StatusTitle from '@/components/StatusTitle.vue'
import { systemUnavailable } from '@/mixins/system-unavailable.js'

export default {
  name: 'UserTableBody',
  components: {
    StatusTitle: StatusTitle,
    BaseActionMenu: () => import('@/base/BaseActionMenu.vue')
  },
  mixins: [fullName, userRights, getRoleTitle, systemUnavailable],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      actions: {
        edit: this.$t('button.edit'),
        resetPass: this.$t('button.resetPass')
      }
    }
  },
  computed: {
    isStatusUnRegistered() {
      return this.user.status === userStatus.unregistered
    },
    roles() {
      return this.getRolesTitlesList(this.user.user_roles)
    },
    fullName() {
      return this.getFullName(this.user)
    },
    availableActions() {
      if (!(this.isAnyAdmin && !this.isStatusUnRegistered)) {
        delete this.actions.resetPass
      }
      return this.actions
    },
    isUserAdmin() {
      if (this.isNeuroAdmin) {
        if (this.user.user_roles.some(role => role == 'hospital_admin' || role == 'neuro_admin')) return true
        else return false
      } else return true
    }
  },
  methods: {
    clickResetUserPwd() {
      this.$emit('click-reset', this.user)
    },
    itemClicked(item) {
      if (Number(localStorage.getItem('activeHospital'))) {
        if (item == 'edit') {
          this.$router.push({ name: 'user-edit', params: { id: this.user.id } })
        } else if (item == 'resetPass') {
          this.clickResetUserPwd()
        }
      } else {
        this.$emit('system:unavailable')
      }
    }
  }
}
</script>
